import { StandardEvents } from '@shopify/events';

class SabinalCartCount extends HTMLElement {
  connectedCallback() {
    document.addEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    window.addEventListener('pageshow', this.onPageShow);
    if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') this.refresh();
  }

  disconnectedCallback() {
    document.removeEventListener(StandardEvents.cartLinesUpdate, this.onCartUpdate);
    window.removeEventListener('pageshow', this.onPageShow);
    this.controller?.abort();
  }

  render(count) {
    if (Number.isInteger(count) && count >= 0) this.textContent = String(count);
  }

  onCartUpdate = (event) => {
    const revision = this.revision = (this.revision || 0) + 1;
    this.controller?.abort();
    event.promise?.then(({ cart, detail }) => {
      if (revision === this.revision) this.render(cart?.totalQuantity ?? detail?.itemCount);
    }).catch(() => {});
  };

  onPageShow = (event) => {
    if (event.persisted) this.refresh();
  };

  async refresh() {
    this.controller?.abort();
    const controller = this.controller = new AbortController();
    const revision = this.revision || 0;
    try {
      const response = await fetch(this.dataset.cartUrl, {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' },
        signal: controller.signal
      });
      if (!response.ok) return;
      const cart = await response.json();
      if (!controller.signal.aborted && revision === (this.revision || 0)) this.render(cart.item_count);
    } catch {}
  }
}

if (!customElements.get('sabinal-cart-count')) customElements.define('sabinal-cart-count', SabinalCartCount);
